module.exports = __webpack_public_path__ + "img/726.1ffd6fec.jpg";